import { TimerType, useMutableRef, useTimer } from '@carnica/utils/hooks';
import { useEffect, useMemo, useRef } from 'react';
/**
 * @description хук создает таймер для автоматического проигрывания анимации прогресс бара
 */
export var useProgressTimer = function useProgressTimer(params) {
  var duration = params.duration,
    steps = params.steps,
    mode = params.mode,
    isActive = params.isActive,
    onIntervalProp = params.onInterval,
    onTimeOver = params.onTimeOver;
  var onIntervalRef = useMutableRef(onIntervalProp);
  var isActiveRef = useMutableRef(isActive);
  var totalDuration = duration * steps;
  var interval = duration / 10;

  /**
   * @desc Флаг для игнорирования срабатывания таймера в момент смены шага
   */
  var ignoreIntervalRef = useRef(false);
  var onInterval = function onInterval(time) {
    // Игнорируем вызов в момент смены шага
    if (ignoreIntervalRef.current) {
      return;
    }
    onIntervalRef.current(Math.min((totalDuration - time) / duration, steps));
  };
  var timer = useTimer({
    endTime: 0,
    interval: interval,
    startTime: totalDuration,
    timerType: TimerType.DECREMENTAL,
    onInterval: onInterval,
    onTimeOver: onTimeOver
  });
  var resetTimer = function resetTimer(time) {
    timer.reset(time);
    if (isActiveRef.current) {
      timer.start();
    }
  };
  var setIgnoreInterval = function setIgnoreInterval(flag) {
    ignoreIntervalRef.current = flag;
  };
  useEffect(function () {
    // При автоматическом проигрывании в заисимости от флага включаем или выключаем анимацию
    if (mode === 'auto' && timer.time.current !== 0) {
      timer[isActive ? 'start' : 'pause']();
    }
  }, [isActive]);
  return useMemo(function () {
    return {
      timer: timer,
      resetTimer: resetTimer,
      setIgnoreInterval: setIgnoreInterval,
      ignoreIntervalRef: ignoreIntervalRef
    };
  }, [timer]);
};